// bundle-builder.js — standalone configurable bundle builder
// Reads product config from window.TL_BUNDLE_SETTINGS (set by sections/bundle-builder.liquid).
// Falls back to Mack Weldon boxer brief defaults when used without settings.
// Communicates with light-cart-drawer.js via custom events:
//   dispatches 'tl:cart:open'  — ask cart drawer to open and render
//   dispatches 'tl:toast'      — ask cart drawer to show a toast (detail.html)
(function () {

  /* ---- Icon helper (inline — no shared dep required) ---- */
  const PATHS = {
    cart:     'M6 6h15l-1.5 9h-12L5 3H2M9 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM18 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
    check:    'M20 6L9 17l-5-5',
    truck:    'M3 6h11v9H3zM14 9h4l3 3v3h-7M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
    shield:   'M12 2l8 3v6c0 5-3.5 8.5-8 11-4.5-2.5-8-6-8-11V5l8-3zM9 12l2 2 4-4',
    tag:      'M3 3h8l10 10-8 8L3 11V3zM7.5 7.5h.01',
  };
  function icon(name, size, color, filled) {
    const isFilled = filled || false;
    return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="${isFilled ? color : 'none'}" stroke="${color}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${PATHS[name] || ''}"/></svg>`;
  }
  function money(n) { return '$' + n.toFixed(2).replace(/\.00$/, ''); }
  function showToast(html) {
    window.dispatchEvent(new CustomEvent('tl:toast', { detail: { html } }));
  }

  /* ---- Read settings ---- */
  const CFG = window.TL_BUNDLE_SETTINGS || {};

  /* ---- Build product catalog from settings, falling back to boxer brief defaults ---- */
  const DEFAULT_ACCENTS      = ['#33b4cc', '#c2386f', '#8ba84f'];
  const DEFAULT_ACCENTS_DEEP = ['#1f8da3', '#9e2a58', '#6c8a36'];
  const DEFAULT_ACCENTS_SOFT = ['#e5f7fa', '#fbe8f0', '#f0f5e5'];

  const configuredProducts = CFG.products
    ? Object.values(CFG.products).filter(p => p && p.handle)
    : [];

  const FABRICS = configuredProducts.length
    ? configuredProducts.map((p, i) => ({
        id:         'p' + i,
        handle:     p.handle,
        name:       p.label || p.handle,
        price:      0,
        accent:     DEFAULT_ACCENTS[i]      || '#1c9aff',
        accentDeep: DEFAULT_ACCENTS_DEEP[i] || '#0074e0',
        soft:       DEFAULT_ACCENTS_SOFT[i] || '#e5f7fa',
      }))
    : [
        { id: '18hour',   handle: '18-hour-jersey-boxer-briefs', name: '18-Hour Jersey', price: 30, accent: '#33b4cc', accentDeep: '#1f8da3', soft: '#e5f7fa' },
        { id: 'airknitx', handle: 'airknitx-boxer-brief',        name: 'AIRKNITx',       price: 34, accent: '#c2386f', accentDeep: '#9e2a58', soft: '#fbe8f0' },
        { id: 'silver',   handle: 'silver-boxer-brief',          name: 'Silver',          price: 40, accent: '#8ba84f', accentDeep: '#6c8a36', soft: '#f0f5e5' },
      ];

  const FABRIC_MAP = {};
  FABRICS.forEach(f => { FABRIC_MAP[f.id] = f; });

  // Only render fabric pills when there are multiple products to choose between
  const SHOW_FABRIC_PILLS = FABRICS.length > 1;

  const TIERS = [
    { size: 3, off: 0.05, label: '3-Pack' },
    { size: 6, off: 0.07, label: '6-Pack', popular: true },
    { size: 9, off: 0.10, label: '9-Pack', best: true },
  ];

  // Sizes read from the first product's variant options after data loads;
  // falls back to CFG.sizes or the standard MW size run.
  let SIZES = CFG.sizes || ['S', 'M', 'L', 'XL', 'XXL'];

  const NEW_CUST_RATE = (CFG.newCustomerRate != null) ? CFG.newCustomerRate : 0.20;
  const NEW_CUST_MIN  = (CFG.newCustomerThreshold != null) ? CFG.newCustomerThreshold : 125;
  const NEW_CUST_CODE = CFG.newCustomerCode || 'MW-NEW-20';

  /* ---- Shop data ---- */
  const shopData = {};

  function getColors(fabricId) {
    return shopData[fabricId]?.colors || [];
  }

  function lookupVariant(fabricId, colorName, size) {
    return shopData[fabricId]?.variantMap?.[colorName + '|' + size] || null;
  }

  function lookupPrice(fabricId, colorName, size) {
    return shopData[fabricId]?.variantPrices?.[colorName + '|' + size] ?? FABRIC_MAP[fabricId]?.price ?? 0;
  }

  /* ---- Storefront API swatch fetch ---- */
  function fetchAllProductData() {
    const sfToken = window.TL_SF_TOKEN || '';
    const aliases = FABRICS.map((f, i) => `p${i}: product(handle: ${JSON.stringify(f.handle)}) { ...CS }`).join('\n');
    const sfQuery = `{ ${aliases} }
      fragment CS on Product {
        colorSettings: metafield(key: "color_settings", namespace: "custom") {
          references(first: 50) {
            nodes {
              ... on Metaobject {
                fields { key value reference { ... on MediaImage { image { url } } } }
              }
            }
          }
        }
      }`;

    const swatchFetch = fetch('/api/2024-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sfToken },
      body: JSON.stringify({ query: sfQuery })
    })
      .then(r => r.json())
      .then(data => {
        FABRICS.forEach((f, i) => {
          const nodes = data?.data?.['p' + i]?.colorSettings?.references?.nodes || [];
          if (!shopData[f.id]) shopData[f.id] = {};
          const swatches = {};
          nodes.forEach(n => {
            const fields = {};
            n.fields.forEach(fld => { fields[fld.key] = fld; });
            const title  = fields.color_title?.value;
            const imgUrl = fields.swatch_image?.reference?.image?.url;
            if (title && imgUrl) swatches[title] = imgUrl;
          });
          shopData[f.id].swatches = swatches;
        });
      })
      .catch(() => {});

    const variantFetch = Promise.all(
      FABRICS.map(f =>
        fetch('/products/' + f.handle + '.js')
          .then(r => r.json())
          .then(p => {
            if (!shopData[f.id]) shopData[f.id] = {};
            const variantMap   = {};
            const variantPrices = {};
            p.variants.forEach(v => {
              const key = v.option1 + '|' + v.option2;
              if (v.available) variantMap[key] = v.id;
              variantPrices[key] = v.price / 100;
            });

            // Derive available colors in Shopify option order
            const colorOption = p.options.find(o => o.name === 'Color');
            const seen = new Set();
            const availableColors = [];
            (colorOption ? colorOption.values : []).forEach(c => {
              if (!seen.has(c) && Object.keys(variantMap).some(k => k.startsWith(c + '|'))) {
                seen.add(c);
                availableColors.push(c);
              }
            });

            // Populate SIZES from first product's size option (only when not overridden by CFG)
            if (!CFG.sizes && f.id === FABRICS[0].id) {
              const sizeOption = p.options.find(o => o.name === 'Size');
              if (sizeOption?.values?.length) SIZES = sizeOption.values;
            }

            const variantImageMap = {};
            p.variants.forEach(v => {
              if (!variantImageMap[v.option1] && v.featured_image?.src) {
                variantImageMap[v.option1] = shopifyImgCrop(v.featured_image.src, 96, 120);
              }
            });

            shopData[f.id].variantMap     = variantMap;
            shopData[f.id].variantPrices  = variantPrices;
            shopData[f.id].availableColors = availableColors;
            shopData[f.id].variantImageMap = variantImageMap;
          })
          .catch(() => {})
      )
    );

    return Promise.all([swatchFetch, variantFetch]).then(() => {
      FABRICS.forEach(f => {
        const d = shopData[f.id] || {};
        const swatches  = d.swatches  || {};
        const available = new Set(d.availableColors || []);
        d.colors = (d.availableColors || [])
          .slice(0, 8)
          .map(name => ({ name, imgUrl: swatches[name] || null }));
      });
    });
  }

  function shopifyImgCrop(src, w, h) {
    if (!src) return src;
    const clean = src.replace(/_\d+x\d+(_crop_\w+)?\.(jpg|jpeg|png|gif|webp)/i, '.$2');
    return clean.replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i, `_${w}x${h}_crop_center.$1$2`);
  }

  function swatchStyle(c) {
    if (c && c.imgUrl) return `background-image:url(${c.imgUrl});background-size:cover;background-color:#ccc`;
    return 'background:#ccc';
  }

  function getVariantImage(fabricId, colorName) {
    return shopData[fabricId]?.variantImageMap?.[colorName] || null;
  }

  /* ---- Bundle state ---- */
  function makeSlots(n) {
    return Array.from({ length: n }, (_, i) => {
      const f = FABRICS[i % FABRICS.length];
      return { fabricId: f.id, color: getColors(f.id)[0]?.name || '', size: SIZES[1] || SIZES[0] || 'M' };
    });
  }

  let bundle = { tierIdx: 1, slots: makeSlots(TIERS[1].size) };

  function calcBundle() {
    const tier = TIERS[bundle.tierIdx];
    const subtotal    = bundle.slots.reduce((s, sl) => s + lookupPrice(sl.fabricId, sl.color, sl.size), 0);
    const bundleDisc  = subtotal * tier.off;
    const afterBundle = subtotal - bundleDisc;
    const eligible    = afterBundle >= NEW_CUST_MIN;
    const newDisc     = eligible ? afterBundle * NEW_CUST_RATE : 0;
    const total       = afterBundle - newDisc;
    const saved       = bundleDisc + newDisc;
    const toThreshold = Math.max(0, NEW_CUST_MIN - afterBundle);
    const freeShipping = afterBundle >= 150;
    return { tier, subtotal, bundleDisc, afterBundle, eligible, newDisc, total, saved, toThreshold, freeShipping };
  }

  /* ---- Email-submitted flag ---- */
  let _emailSubmitted = sessionStorage.getItem('tl_email_sub') === '1';

  /* ---- Render ---- */
  function renderBundle() {
    const left  = document.getElementById('tl-bundle-left');
    const right = document.getElementById('tl-bundle-right');
    if (!left || !right) return;

    const { tier, subtotal, bundleDisc, eligible, newDisc, total, saved, toThreshold, afterBundle, freeShipping } = calcBundle();

    const tiersHtml = TIERS.map((t, i) => `
      <button class="tier disp${i === bundle.tierIdx ? ' is-on' : ''}" data-tier="${i}">
        ${t.popular ? '<span class="tier__flag">Most popular</span>' : ''}
        ${t.best    ? '<span class="tier__flag tier__flag--best">Best value</span>' : ''}
        <span class="tier__size">${t.size}</span>
        <span class="tier__label">${t.label}</span>
        <span class="tier__off">${Math.round(t.off * 100)}% off</span>
      </button>`).join('');

    const slotsHtml = bundle.slots.map((sl, i) => {
      const f      = FABRIC_MAP[sl.fabricId];
      const colors = getColors(sl.fabricId);
      const col    = colors.find(c => c.name === sl.color) || colors[0] || { name: '', imgUrl: null };

      const fabricPills = SHOW_FABRIC_PILLS
        ? FABRICS.map(opt => `
            <button class="fpill${opt.id === sl.fabricId ? ' is-on' : ''}" data-slot="${i}" data-action="fabric" data-value="${opt.id}"
              style="${opt.id === sl.fabricId ? `background:${f.accent};border-color:${f.accent};color:#fff` : ''}">${opt.name}</button>`).join('')
        : '';

      const colorDots = colors.map(c => {
        const sizeAvail = !!lookupVariant(sl.fabricId, c.name, sl.size);
        return `<button class="cdot${c.name === sl.color ? ' is-on' : ''}${!sizeAvail ? ' is-oos' : ''}" data-slot="${i}" data-action="color" data-value="${c.name}"
          aria-label="${c.name}" title="${c.name}" style="${swatchStyle(c)}"></button>`;
      }).join('');

      const sizeBtns = SIZES.map(s => {
        const avail = !!lookupVariant(sl.fabricId, sl.color, s);
        return `<button class="szchip${s === sl.size ? ' is-on' : ''}${!avail ? ' is-oos' : ''}" data-slot="${i}" data-action="size" data-value="${s}"${!avail ? ' disabled' : ''}>${s}</button>`;
      }).join('');

      const varImg = getVariantImage(sl.fabricId, col.name);
      return `
        <div class="slot">
          <div class="slot__chip"${varImg ? '' : ` style="${swatchStyle(col)}"`}>
            ${varImg ? `<img class="slot__chip-img" src="${varImg}" alt="${col.name}">` : `<span class="slot__num">${i + 1}</span>`}
          </div>
          <div class="slot__body">
            <div class="slot__row1">
              ${SHOW_FABRIC_PILLS ? `<div class="slot__fabrics">${fabricPills}</div>` : `<div class="slot__name">${f.name}</div>`}
              <span class="slot__price">${money(lookupPrice(sl.fabricId, col.name, sl.size))}</span>
            </div>
            <div class="slot__row2">
              <div class="slot__colors">${colorDots}</div>
              <div class="slot__sizes">${sizeBtns}</div>
            </div>
            <div class="slot__cname">${col.name}</div>
          </div>
        </div>`;
    }).join('');

    left.innerHTML = `
      <div class="tiers">${tiersHtml}</div>
      <div class="slots">
        <div class="slots__head">
          <span>Build your ${tier.label.toLowerCase()}</span>
          <span class="slots__hint">Tap to swap ${SHOW_FABRIC_PILLS ? 'fabric, ' : ''}color &amp; size</span>
        </div>
        ${slotsHtml}
      </div>`;

    const summaryDots = bundle.slots.slice(0, 9).map(sl => {
      const colors = getColors(sl.fabricId);
      const c = colors.find(x => x.name === sl.color) || colors[0] || { imgUrl: null };
      return `<span class="summary__dot" style="${swatchStyle(c)}"></span>`;
    }).join('');

    const nudge = eligible
      ? `<div class="summary__unlocked">${icon('check', 15, 'var(--success)')} ${Math.round(NEW_CUST_RATE * 100)}% off unlocked — enter ${_emailSubmitted ? `<span class="disc-code">${NEW_CUST_CODE}</span>` : 'code'} at checkout</div>`
      : `<div class="summary__nudge">Add <strong>${money(toThreshold)}</strong> more to unlock your <strong>${Math.round(NEW_CUST_RATE * 100)}% first-order discount</strong>
           <div class="nudgebar"><span style="width:${Math.min(100, (afterBundle / NEW_CUST_MIN) * 100).toFixed(1)}%"></span></div></div>`;

    const shippingNudge = freeShipping
      ? `<div class="summary__unlocked">${icon('check', 15, 'var(--success)')} Free shipping unlocked</div>`
      : '';

    const newDiscLine = eligible
      ? `<div class="sline sline--save"><span>New Customer (${Math.round(NEW_CUST_RATE * 100)}%)</span><span>−${money(newDisc)}</span></div>`
      : '';

    right.innerHTML = `
      <div class="summary">
        <div class="summary__pack">${summaryDots}</div>
        <h3 class="summary__title disp">Your ${tier.label}</h3>
        ${nudge}
        ${shippingNudge}
        <div class="summary__lines">
          <div class="sline"><span>Subtotal (${tier.size} pairs)</span><span>${money(subtotal)}</span></div>
          <div class="sline sline--save"><span>${tier.label} discount (${Math.round(tier.off * 100)}%)</span><span>−${money(bundleDisc)}</span></div>
          ${newDiscLine}
        </div>
        <div class="summary__total">
          <span>Total</span>
          <span class="summary__big">${money(total)}</span>
        </div>
        <div class="summary__saved">You save ${money(saved)} (${Math.round((saved / subtotal) * 100)}%)</div>
        <button class="btn btn--accent btn--block btn--lg" id="tl-add-btn" data-action="add-bundle">
          ${icon('cart', 17, '#fff')} Add bundle — ${money(total)}
        </button>
        <ul class="summary__perks">
          <li>${icon('truck',  15, 'var(--navy)')} Free shipping over $150</li>
          <li>${icon('shield', 15, 'var(--navy)')} 30-day Try-On Guarantee</li>
          <li>${icon('tag',    15, 'var(--navy)')} No-roll waistband, stay-put legs, tagless</li>
        </ul>
      </div>`;
  }

  /* ---- Event binding ---- */
  function bindBundleEvents() {
    const left  = document.getElementById('tl-bundle-left');
    const right = document.getElementById('tl-bundle-right');
    if (!left || !right) return;

    left.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-action],[data-tier]');
      if (!btn) return;

      if (btn.dataset.tier !== undefined) {
        const idx     = parseInt(btn.dataset.tier);
        const newSize = TIERS[idx].size;
        const newSlots = Array.from({ length: newSize }, (_, i) =>
          i < bundle.slots.length ? bundle.slots[i] : {
            fabricId: FABRICS[i % FABRICS.length].id,
            color:    getColors(FABRICS[i % FABRICS.length].id)[0]?.name || '',
            size:     SIZES[1] || SIZES[0] || 'M',
          });
        bundle = { ...bundle, tierIdx: idx, slots: newSlots };
        renderBundle();
        return;
      }

      const slotIdx = parseInt(btn.dataset.slot);
      const action  = btn.dataset.action;
      const value   = btn.dataset.value;
      let newSlots  = bundle.slots.slice();

      if (action === 'fabric') {
        const newColor = getColors(value)[0]?.name || '';
        let newSize = newSlots[slotIdx].size;
        if (!lookupVariant(value, newColor, newSize)) {
          newSize = SIZES.find(s => lookupVariant(value, newColor, s)) || newSize;
        }
        newSlots[slotIdx] = { ...newSlots[slotIdx], fabricId: value, color: newColor, size: newSize };
      } else if (action === 'color') {
        const fid = newSlots[slotIdx].fabricId;
        let newSize = newSlots[slotIdx].size;
        if (!lookupVariant(fid, value, newSize)) {
          newSize = SIZES.find(s => lookupVariant(fid, value, s)) || newSize;
        }
        newSlots[slotIdx] = { ...newSlots[slotIdx], color: value, size: newSize };
      } else if (action === 'size') {
        newSlots[slotIdx] = { ...newSlots[slotIdx], size: value };
      }
      bundle = { ...bundle, slots: newSlots };
      renderBundle();
    });

    right.addEventListener('click', function (e) {
      if (e.target.closest('[data-action="add-bundle"]')) handleAddBundle();
    });
  }

  async function handleAddBundle() {
    const addBtn = document.getElementById('tl-add-btn');
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = '…'; }

    const { tier, total } = calcBundle();
    const variantIds = bundle.slots.map(sl => lookupVariant(sl.fabricId, sl.color, sl.size));

    if (variantIds.some(id => !id)) {
      showToast('Some variants are unavailable — try a different color or size.');
      if (addBtn) { addBtn.disabled = false; addBtn.innerHTML = icon('cart', 17, '#fff') + ' Add bundle — ' + money(total); }
      return;
    }

    const bundleId       = btoa(variantIds.join(',') + ':' + Date.now());
    const discountPercent = Math.round(tier.off * 100).toString();
    const displayImage   = getVariantImage(bundle.slots[0].fabricId, bundle.slots[0].color) || '';
    const bundleTitle    = (CFG.bundleTitle || '{label} Bundle')
      .replace('{size}',  tier.size.toString())
      .replace('{label}', tier.label);

    const items = bundle.slots.map((sl, i) => ({
      id:         variantIds[i],
      quantity:   1,
      properties: {
        _curated_bundle_identifier: bundleId,
        _bundleType:         'custom_bundle',
        _title:              bundleTitle,
        _cart_display_image: displayImage,
        _bundle_pack_size:   tier.size.toString(),
        _bundle_size_scheme: sl.size,
        _bundle_origin:      CFG.bundleOrigin || 'lp',
        _bundle_ids:         variantIds.join(','),
        _discount:           discountPercent,
      }
    }));

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('cart');
      window.dispatchEvent(new CustomEvent('tl:cart:open'));
    } catch (_) {
      showToast('Couldn\'t add to cart — please try again.');
    } finally {
      if (addBtn) { addBtn.disabled = false; addBtn.innerHTML = icon('cart', 17, '#fff') + ' Add bundle — ' + money(total); }
    }
  }

  /* ---- Init ---- */
  function init() {
    renderBundle();
    bindBundleEvents();

    window.addEventListener('klaviyoForms', function (e) {
      if (e.detail?.type === 'submit') {
        _emailSubmitted = true;
        sessionStorage.setItem('tl_email_sub', '1');
        renderBundle();
      }
    });

    fetchAllProductData().then(() => {
      bundle.slots = bundle.slots.map(sl => {
        const colors = getColors(sl.fabricId);
        let color = sl.color;
        if (!colors.find(c => c.name === color)) color = colors[0]?.name || color;
        let size = sl.size;
        if (!lookupVariant(sl.fabricId, color, size)) {
          size = SIZES.find(s => lookupVariant(sl.fabricId, color, s)) || size;
        }
        return { ...sl, color, size };
      });
      renderBundle();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
